const config = {
	api: {
		hostUrl: 'wss://api.nercia.se/',
		webResourcePath: 'https://api.nercia.se/api/'
	},
	auth: {
		loginUrl: 'https://api.nercia.se/auth',
		logoutUrl: 'https://api.nercia.se/auth/logout',
		authenticateUrl: 'https://api.nercia.se/auth?noredirect',
		actionUrl: 'https://api.nercia.se/auth/action'
	},
	file: {
		uploadUrl: 'https://api.nercia.se/file/'
	},
	sentry: {
		dsn: 'https://c8b9dbbd6c85a22b3b5545f2653bd196@o4505799358021632.ingest.sentry.io/4505799365033984',
		environment: 'production',
		tracesSampleRate: 0.1,
	},
	readerWidget: {
		active: true,
		customer: 'J2XcK7ywgdCFxVZgXxpt',
		domain: 'mitt.nercia.se',
	}
};

export default config;
